import * as Printf from "bs-platform/lib/es6/printf.js";
var SolvuuLang0 = {};
var fprintf = Printf.fprintf;
var printf = Printf.printf;
var eprintf = Printf.eprintf;
var sprintf = Printf.sprintf;
var bprintf = Printf.bprintf;
var ifprintf = Printf.ifprintf;
var kfprintf = Printf.kfprintf;
var ikfprintf = Printf.ikfprintf;
var ksprintf = Printf.ksprintf;
var kbprintf = Printf.kbprintf;
var kprintf = Printf.kprintf;
var Bolt0 =
/* alias */
0;
var Lang0 =
/* alias */
0;
export { fprintf, printf, eprintf, sprintf, bprintf, ifprintf, kfprintf, ikfprintf, ksprintf, kbprintf, kprintf, Bolt0, Lang0, SolvuuLang0 };
/* No side effect */